import { axios } from '@Root/API'

export const moodle = params => {
	return axios.get('export/moodle-contacts', {
		params,
	})
}
